import { render, staticRenderFns } from "./showImg.vue?vue&type=template&id=4fdb7fc5"
import script from "./showImg.vue?vue&type=script&lang=js"
export * from "./showImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports